// test822
(822 && 0);
